import React, {Component} from 'react';
import TeamLogo from './TeamLogo';

class Team extends Component {
    render() {
        const team = this.props.team;
        const round = this.props.round;
        const winChance = team['rd' + round + '_win'];
        let opacity = 1;

        if (winChance === 1) {
            opacity = 1;
        } else if (winChance === 0) {
            opacity = .1;
        } else {
            opacity = .7;
        }

        return (
            <div
                onClick={() => {this.props.onClick(team, this.props.round)}}
                onMouseEnter={() => {this.props.onHover(team, this.props.round)}}>
                <TeamLogo team={team} small={this.props.small} opacity={opacity}></TeamLogo>
            </div>
        );
    }
}

export default Team;